/**
 * @fileoverview POST handler for the "/data_objects/:type_name/:object_id/users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectIdUsers } from "./constants";
import type {
  PostCustomObjectsTypeNameObjectIdUsersParams,
  PostCustomObjectsTypeNameObjectIdUsersResponse,
} from "./types";

export const postCustomObjectsTypeNameObjectIdUsers = reactQueryMutationAdapter(
  customObjectsTypeNameObjectIdUsers,
  ({
    appGroupId,
    typeName,
    objectId,
    users,
  }: PostCustomObjectsTypeNameObjectIdUsersParams): Promise<PostCustomObjectsTypeNameObjectIdUsersResponse> => {
    return fetch<PostCustomObjectsTypeNameObjectIdUsersResponse>(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}/users`,
      "POST",
      { app_group_id: appGroupId, users },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
